import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import mainLogo from "../../assets/Main Logo.png";
import brandIcon from "../../assets/Brand_Main Icon.png";

const navLinks = [
  { label: "Services",     id: "services" },
  { label: "Process",      id: "process" },
  { label: "Why Us",       id: "why" },
  { label: "Testimonials", id: "testimonials" },
  { label: "Contact",      id: "contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const ctaRef = useRef(null);
  const scrollFrameRef = useRef(null);

  useEffect(() => {
    const updateScrolledState = () => {
      scrollFrameRef.current = null;
      const position = window.scrollY;

      // Hysteresis prevents the nav from rapidly swapping states around one threshold.
      setScrolled((isScrolled) => (isScrolled ? position > 12 : position > 44));
    };
    const onScroll = () => {
      if (scrollFrameRef.current === null) {
        scrollFrameRef.current = requestAnimationFrame(updateScrolledState);
      }
    };

    updateScrolledState();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (scrollFrameRef.current !== null) cancelAnimationFrame(scrollFrameRef.current);
    };
  }, []);

  const handleCtaMouseMove = (e) => {
    if (!ctaRef.current) return;
    const rect = ctaRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctaRef.current.style.setProperty('--x', `${x}px`);
    ctaRef.current.style.setProperty('--y', `${y}px`);
  };

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__inner">
        <button className="navbar__logo-btn" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <div className="navbar__logo-container">
            <img src={mainLogo} alt="Placify Innovative" className="navbar__logo-img" />
            <div className="navbar__logo-hover-circle">
              <img src={brandIcon} alt="" className="navbar__logo-icon" />
            </div>
          </div>
        </button>

        <ul className="navbar__links">
          {navLinks.map((link) => (
            <li key={link.id}>
              <button className="navbar__link" onClick={() => scrollTo(link.id)}>
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          ref={ctaRef}
          className="navbar__cta"
          onClick={() => scrollTo("contact")}
          onMouseMove={handleCtaMouseMove}
        >
          <span>Get Started</span>
        </button>

        <button
          className={`navbar__hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      <div className={`navbar__mobile ${menuOpen ? "navbar__mobile--open" : ""}`}>
        {navLinks.map((link) => (
          <button key={link.id} className="navbar__mobile-link" onClick={() => scrollTo(link.id)}>
            {link.label}
          </button>
        ))}
        <button className="navbar__mobile-cta" onClick={() => scrollTo("contact")}>
          Get Started →
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
